import { useApp } from "../../context/AppContext";
import defaultLogo from "../../assets/images/cicoplogo.png";

/**
 * CollegeLogoBadge
 * ────────────────
 * A reusable component that renders the dynamic college logo from the database
 * with institutional branding accents (subtle #003b67 border & soft elevation).
 */
export default function CollegeLogoBadge({
    size = 52,
    borderRadius = 10,
    showName = false,
    nameStyle = {},
    style = {},
    imgStyle = {},
}) {
    const { collegeName, logoSrc } = useApp();
    const resolvedLogo = logoSrc || defaultLogo;

    const badge = (
        <div
            style={{
                width: size,
                height: size,
                borderRadius,
                background: "#ffffff",
                border: "1.5px solid rgba(0, 59, 103, 0.18)",
                boxShadow: "0 2px 8px rgba(0, 59, 103, 0.08)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "3px",
                flexShrink: 0,
                overflow: "hidden",
                ...style,
            }}
        >
            <img
                src={resolvedLogo}
                alt={collegeName || "College Logo"}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    ...imgStyle,
                }}
            />
        </div>
    );

    if (!showName) return badge;

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "0.85rem" }}>
            {badge}
            <div>
                <div
                    style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        color: "#003b67",
                        letterSpacing: "0.04em",
                        textTransform: "uppercase",
                        ...nameStyle,
                    }}
                >
                    {collegeName}
                </div>
            </div>
        </div>
    );
}
